// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardWrapper_wrapper__jWaCa","settings":"DashboardWrapper_settings__Te12C"};